/*                                    */
import { branch, effect, destroy_effect, managed } from '../../reactivity/effects.js';

/*                                                                      */
/*                                                                     */
/*                                                */

/**
 *
 *
 */
export function attach(node, get_fn) {
	/*                                                        */
	var fn = undefined;

	/*                        */
	var e;

	managed(() => {
		if (fn !== (fn = get_fn())) {
			if (e) {
				destroy_effect(e);
				e = null;
			}

			if (fn) {
				e = branch(() => {
					effect(() => /*                                  */ (fn)(node));
				});
			}
		}
	});
}
